import { render, staticRenderFns } from "./detail-discount.vue?vue&type=template&id=cb9f31c4&"
import script from "./detail-discount.vue?vue&type=script&lang=js&"
export * from "./detail-discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports